@if (sideNavService.open$ | async) {
  <div class="tw-h-px tw-w-full tw-my-2 tw-bg-secondary-300"></div>
}
